"use client";

import { useContext } from "react";
import { RtlContext } from "@/providers/RtlProvider";

export const useRtl = () => {
  return useContext(RtlContext);
};
